import { Component, HostListener, OnDestroy, OnInit } from '@angular/core'
import { SharedServices } from '../../../../services/shared.services'
import { FormBuilder } from '@angular/forms'
import { AuthService } from '../../../../services/auth.services'
import { ModalService } from '../../../../services/modal.service'
import { RestServices } from '../../../../services/rest.services'

@Component({
    selector: 'app-modal-communication-newroom',
    templateUrl: './modal-communication-newroom.component.html',
    styleUrls: ['../../../../stagingcss/root-ui-view.component.css', './modal-communication-newroom.component.css'],
})
export class ModalCommunicationNewroomComponent implements OnInit, OnDestroy {
    showNewRomm = 'hidden'
    showNewRommUser = 'hidden'
    confirmList = []
    confirmListId = []
    ListNewRommId
    ListNewRommCoppyId
    ListNewRommCoppy
    ListNewRomm
    confirmListUser = []
    confirmListUserId = []
    ListNewRommUserId
    ListNewRommUserCoppyId
    ListNewRommUserCoppy
    ListNewRommUser
    list

    alertMail = true
    alertRoom = true
    langDefault = localStorage.getItem('lang') === 'false' ? 'false' : 'true'
    routerLink
    unscrService

    constructor(private _sharedService: SharedServices, private authData: AuthService, private restApi: RestServices, private formBuider: FormBuilder, private modalService: ModalService) {
        this.unscrService = modalService.changeEmitted$.subscribe(success => {
            // console.log('success', success);
            if (success[0] === 'activeOwnersNewRoom') {
                if (success[1] === undefined) {
                    this.confirmList = []
                    this.confirmListId = []
                    this.listUser()
                }
                this.ListNewRommId = (success[1] ? success[1] : [])
                this.ListNewRomm = (success[2] ? success[2] : [])
                this.confirmListId = (success[1] ? success[1] : [])
                this.confirmList = (success[2] ? success[2] : [])
                this.ListNewRommCoppyId = this.ListNewRommId.slice()
                this.ListNewRommCoppy = this.ListNewRomm && this.ListNewRomm.slice()
            }
            if (success[0] === 'activeUsersNewRoom') {
                if (success[1] === undefined) {
                    this.confirmListUser = []
                    this.confirmListUserId = []
                    this.listUser()
                }
                this.ListNewRommUserId = (success[1] ? success[1] : [])
                this.confirmListUserId = (success[1] ? success[1] : [])
                this.ListNewRommUser = (success[2] ? success[2] : [])
                this.confirmListUser = (success[2] ? success[2] : [])
                this.ListNewRommUserCoppyId = this.ListNewRommUserId.slice()
                this.ListNewRommUserCoppy = this.ListNewRommUser && this.ListNewRommUser.slice()
            }
            if (success === 'activeOwners') {
                this.showNewRomm = 'active'
                // console.log(this.ListNewRommId);
                if (this.ListNewRommId === undefined) {
                    this.confirmList = []
                    this.confirmListId = []
                    this.listUser()
                } else {
                    this.ListNewRommCoppyId = this.ListNewRommId.slice()
                    this.ListNewRommCoppy = this.ListNewRomm && this.ListNewRomm.slice()
                }
                // console.log(this.ListNewRommCoppyId);
            }
            if (success === 'activeUsers') {
                this.showNewRommUser = 'active'
                if (this.ListNewRommUserId === undefined) {
                    this.confirmListUser = []
                    this.confirmListUserId = []
                    this.listUser()
                } else {
                    this.ListNewRommUserCoppyId = this.ListNewRommUserId.slice()
                    this.ListNewRommUserCoppy = this.ListNewRommUser && this.ListNewRommUser.slice()
                }
            }
            if (success[0] === 'activeOwnersApi') {
                this.ListNewRommId = (success[1] ? success[1] : [])
                this.ListNewRommCoppyId = this.ListNewRommId.slice()
                this.confirmListId = (success[1] ? success[1] : [])
                // console.log(success);
            }
            if (success[0] === 'activeUsersApi') {
                this.ListNewRommUserId = (success[1] ? success[1] : [])
                this.ListNewRommUserCoppyId = this.ListNewRommUserId.slice()
                this.confirmListUserId = (success[1] ? success[1] : [])
            }
            if (success === 'activeAlertNewRoomm') {
                this.alertMail = false
                this.alertLanguage()
            }
            if (success === 'activeAlertRoomm') {
                this.alertRoom = false
                this.alertLanguage()
            }
            if (success && success[0] === 'checkRotesLink') {
                this.routerLink = success[1]
            }
            if (success === 'hiddenThenSaveMail') {
                this.ListNewRommId = undefined
                this.ListNewRommUserId = undefined
                this.confirmList = []
                this.confirmListId = []
                this.confirmListUser = []
                this.confirmListUserId = []
            }
        })
        this.listUser()
    }

    ngOnInit() {
    }

    ngOnDestroy() {
        if(this.unscrService)
            this.unscrService.unsubscribe()
    }

    @HostListener('document:keydown', ['$event']) handleKeyboardEvent(event: KeyboardEvent) {
        let keyPressed = event.keyCode
        if (keyPressed === 27) {
            event.preventDefault()
            this.closeModalNewRomm()
        }
    }

    toggleSelection(ev, id, val, key = null) {
        if (key === 'user') {
            if (ev.target.checked) {
                const checkPush1 = this.confirmListUserId.findIndex(el => {
                    return el == id
                })
                if (checkPush1 == -1) {
                    this.confirmListUserId.push(id)
                    this.confirmListUser.push(val)
                }
            } else {
                const checkSplice1 = this.confirmListUserId.findIndex(el => {
                    return el == id
                })
                if (checkSplice1 != -1) {
                    this.confirmListUserId.splice(this.confirmListUserId.indexOf(id), 1)
                    this.confirmListUser.splice(this.confirmListUser.indexOf(val), 1)
                }
            }
        } else {
            if (ev.target.checked) {
                const checkPush2 = this.confirmListId.findIndex(el => {
                    return el == id
                })
                if (checkPush2 == -1) {
                    this.confirmListId.push(id)
                    this.confirmList.push(val)
                }
            } else {
                const checkSplice2 = this.confirmListId.findIndex(el => {
                    return el == id
                })
                if (checkSplice2 != -1) {
                    this.confirmListId.splice(this.confirmListId.indexOf(id), 1)
                    this.confirmList.splice(this.confirmList.indexOf(val), 1)
                }
            }
        }
    }

    // save NewRomm
    saveNewRomm(key) {
        if (key === 'user') {
            this.showNewRommUser = 'hidden'
            this.ListNewRommUserId = this.confirmListUserId
            this.ListNewRommUser = this.confirmListUser
            this.ListNewRommUserCoppyId = this.ListNewRommUserId.slice()
            this.ListNewRommUserCoppy = this.ListNewRommUser && this.ListNewRommUser.slice()
            const arr = [this.ListNewRommUser, this.ListNewRommUserId, 'arrUsers']
            this._sharedService.emitChangeParent(arr)
        } else {
            this.showNewRomm = 'hidden'
            this.ListNewRommId = this.confirmListId
            this.ListNewRomm = this.confirmList
            this.ListNewRommCoppyId = this.ListNewRommId.slice()
            this.ListNewRommCoppy = this.ListNewRomm && this.ListNewRomm.slice()
            const arr = [this.ListNewRomm, this.ListNewRommId, 'arrOwner']
            this._sharedService.emitChangeParent(arr)
        }
    }

    closeModalNewRomm() {
        this.showNewRomm = 'hidden'
        this.showNewRommUser = 'hidden'
        if (this.ListNewRommUserId) {
            this.ListNewRommUserId = this.ListNewRommUserCoppyId
            this.ListNewRommUser = this.ListNewRommUserCoppy
            const arr = [this.ListNewRommUserCoppy, this.ListNewRommUserCoppyId, 'arrUsers']
            this._sharedService.emitChangeParent(arr)
        }
        if (this.ListNewRommId) {
            this.ListNewRommId = this.ListNewRommCoppyId
            this.ListNewRomm = this.ListNewRommCoppy
            const arr1 = [this.ListNewRommCoppy, this.ListNewRommCoppyId, 'arrOwner']
            this._sharedService.emitChangeParent(arr1)
        }
    }

    listUser() {
        const resourceUrl = 'resource'
        const resourceData = {
            actions: [], status: {
                NewRomm: {
                    paths: {
                        '{}': true,
                    },
                }, setting: {
                    map: {
                        common: true,
                    }, paths: {
                        '{}': true,
                    },
                }, staff: {
                    paths: {
                        '{"roles":"cordinator"}': true, '{"roles":"doctor"}': true, '{}': true,
                    },
                    searches: {
                        '{"deleted": {"$ne": true}}': true
                    }
                },
            },
        }
        this.authData.authToken().then(tokenReNew => {
            this.restApi.http_post(resourceUrl, resourceData, tokenReNew).subscribe(success => {
                this.list = success['response']['staff']['searches']["{\"deleted\": {\"$ne\": true}}"] 
                if (this.list) {
                    this.list.sort((a, b) =>  (a.rank > b.rank) ? 1 : -1)
                }
            })
        })
    }


    // alert
    cancelAlert() {
        this.alertMail = true
        this.alertRoom = true
    }

    alertDiscard() {
        this._sharedService.emitChange('statusDiscard')
        this._sharedService.emitChange('activeAlertSaveMail')
        this.alertMail = true
        this.alertRoom = true
        // this.router.navigateByUrl('/app/top');
    }

    saveMail() {
        this._sharedService.emitChange('saveNewRoom')
        this.alertMail = true
    }

    alertLanguage() {
        this.langDefault = localStorage.getItem('lang') === 'false' ? 'false' : 'true'
    }

}



// WEBPACK FOOTER //
// ./src/app/app_manager/modal/communication/newroom/modal-communication-newroom.component.ts